import { IApplicationState } from '../../types/redux';

export const selectRecentlyViewedOffers = (state: IApplicationState) => state.recentlyViewed;
